import React from "react";
import PropTypes from "prop-types";
import { Modal, Button, Alert } from "react-bootstrap";
import { format } from "date-fns";

const PaymentStatement = ({ show, handleClose, record }) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg" animation={true} centered>
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>View Repayment Details</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>

      <Modal.Body>
        {!record || record.length === 0 ? (
          <Alert variant="warning" className="text-center">
            No records found.
          </Alert>
        ) : (
          <table className="table table-striped table-bordered table-hover table-responsive">
            <thead>
              <tr>
                <th>Installment Date</th>
                <th>Installment Amount</th>
                <th>Paid Amount</th>
                <th>Balance</th>
                <th>Remarks</th>
                <th>In Payslip</th>
              </tr>
            </thead>
            <tbody>
              {record.map((item, index) => (
                <tr key={index}>
                  <td>
                    {format(new Date(item.installmentDate), "dd-MM-yyyy")}
                  </td>
                  <td>{item.installmentAmount}</td>
                  <td>{item.paidAmount}</td>
                  <td>{item.balanceAmount}</td>
                  <td>{item.remarks || "—"}</td>
                  <td>{item.showInPayslip ? "Yes" : "No"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Modal.Body>
    </Modal>
  );
};

PaymentStatement.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  record: PropTypes.arrayOf(
    PropTypes.shape({
      slno: PropTypes.number,
      balanceAmount: PropTypes.number,
      code: PropTypes.number,
      companyCode: PropTypes.number,
      createDate: PropTypes.string,
      createUser: PropTypes.string,
      installmentAmount: PropTypes.number,
      installmentDate: PropTypes.string,
      paidAmount: PropTypes.number,
      remarks: PropTypes.string,
      showInPayslip: PropTypes.bool,
    })
  ).isRequired,
};

export default PaymentStatement;
